import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const TOCContainer = styled.div`
  // border: 1px solid #dcdcdc;
  // background-color: #f5f5f5
  // padding: 0px 10px;
  filter: ${props => (props.isBlurred ? 'blur(2px)' : 'none')};
  transition: filter 0.3s ease-in-out;
`;

export const TOCItem = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-left: ${props => (props.isSection ? '15px' : props.isSubSection ? '30px' : '0')};
  font-weight: ${props => (props.isTitle ? 'bold' : 'normal')};
  font-size: ${props => (props.isTitle ? '20px' : props.isSection ? '18px' : '16px')};
`;

export const Dots = styled.span`
  flex-grow: 1;
  border-bottom: 2px dotted black;
  margin: 0 5px;
  padding-top: 10px;
`;

export const PageNumber = styled.span`
  font-weight: ${props => (props.isTitle ? 'bold' : 'normal')};
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  transition: opacity 0.3s ease-in-out;
  opacity: ${props => (props.visible ? '1' : '0')};
  pointer-events: none;
`;

export const OverLayContent = styled.div`
  width: 75%;
  color: white;
  background: rgba(0, 0, 0, 0.5);
  text-align: center;
  padding: 10px;
  border-radius: 10px;
  font-size: 18px;
`;
